import { defineMessages } from 'react-intl';

export default defineMessages({
    'notifications.heading': {
        id: 'notifications.heading',
        defaultMessage: 'Notifications',
        description: 'Heading for the notifications page',
    },
    'notifications.recommendations.subheading': {
        id: 'notifications.recommendations.subheading',
        defaultMessage:
            'We’ll guide you to the most relevant Calm Health content using information you have shared with us. This may include messages about specific conditions, goals or topics of interest to you.',
        description:
            'Subheading for the tips and suggestions notifications page',
    },
    'notifications.tips_suggestions.subheading': {
        id: 'notifications.tips_suggestions.subheading',
        defaultMessage:
            'Get helpful tips from our experts for simple ways to to live your healthiest life every day.',
        description:
            'Subheading for the tips and suggestions notifications page',
    },
    'notifications.updates.subheading': {
        id: 'notifications.updates.subheading',
        defaultMessage:
            'Stay informed about the latest products and services from your friends at Calm Health.',
        description:
            'Subheading for the tips and suggestions notifications page',
    },
    'notifications.email_toggle.heading': {
        id: 'notifications.email_toggle.heading',
        defaultMessage: 'Email Notifications',
        description: 'Heading for the email notifications toggle',
    },
    'notifications.email_toggle.subheading': {
        id: 'notifications.email_toggle.subheading',
        defaultMessage:
            'Most email notifications are not encrypted and there may be some risk that the information in the email may be read by a third party.',
        description: 'Subheading for the email notifications toggle',
    },
    'notifications.email_toggle.update_error': {
        id: 'notifications.email_toggle.update_error',
        defaultMessage:
            'Error updating notification preferences. Please try again later.',
        description: 'Error message for the email notifications toggle',
    },
    'notifications.confirm_dialog.title': {
        id: 'notifications.confirm_dialog.title',
        defaultMessage:
            'Are you sure you would like to turn off email notifications?',
        description: 'Confirmation title for turning off email notifications',
    },
    'notifications.confirm_dialog.subtitle': {
        id: 'notifications.confirm_dialog.subtitle',
        defaultMessage:
            'You will need to opt-in again if you turn them back on.',
        description:
            'Confirmation subtitle for turning off email notifications',
    },
    'notifications.confirm_dialog.turn_off.button': {
        id: 'notifications.confirm_dialog.turn_off.button',
        defaultMessage: 'Turn Off',
        description: 'Confirmation button for turning off email notifications',
    },
    'notifications.dialog.turn_on.title': {
        id: 'notifications.dialog.turn_on.title',
        defaultMessage: 'Please accept the email communications consent',
        description: 'Title for the email communications ON consent dialog',
    },
    'notifications.dialog.turn_on.tos': {
        id: 'notifications.dialog.turn_on.tos',
        defaultMessage:
            'I agree to receive email communications from Calm related to its products and services, upcoming events, and relevant resources. I understand I can edit my communications preferences and/or opt-out at any time.',
        description:
            'Terms of service text for the email communications ON consent dialog',
    },
    'notifications.dialog.turn_on.edit_button': {
        id: 'notifications.dialog.turn_on.edit_button',
        defaultMessage: 'How to edit your Communication preferences',
        description:
            'Edit button text for the email communications ON consent dialog',
    },
    'notifications.dialog.turn_on.error_text': {
        id: 'notifications.dialog.turn_on.error_text',
        defaultMessage: 'Error: Agreement to consent required',
        description:
            'Error text for the email communications ON consent dialog',
    },
    'notifications.dialog.check_email.title': {
        id: 'notifications.dialog.check_email.title',
        defaultMessage:
            'Great! Please check your email to confirm your preferences.',
        description: 'Title for the double opt in confirm dialog',
    },
    'notifications.dialog.check_email.subtitle': {
        id: 'notifications.dialog.check_email.subtitle',
        defaultMessage:
            "You won’t receive email notifications until confirmed. Didn't receive an email? Contact Calm Health support.",
        description: 'Subtitle for the double opt in confirm dialog',
    },
    'notifications.dialog.double_opt_in.confirm.title': {
        id: 'notifications.dialog.double_opt_in.confirm.title',
        defaultMessage: 'Email Preferences Confirmed!',
        description:
            'Title for the double opt in confirm dialog when confirming email address',
    },
    'notifications.dialog.double_opt_in.confirm.subtitle': {
        id: 'notifications.dialog.double_opt_in.confirm.subtitle',
        defaultMessage:
            'You will now start receiving relevant resources from our marketing team.',
        description:
            'Title for the double opt in confirm dialog when confirming email address',
    },
});
